import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
export const trackMyMenuClicked = (position, type)=>{
    mixpanelEvent("My Menu Clicked", {
        Position: position,
        Type: type
    });
};
export const trackMyPageDropdownMenuClicked = (menuName)=>{
    mixpanelEvent("MyPage Menu Clicked", {
        Position: "마이 쏠북 드롭다운 메뉴",
        "Menu Name": menuName
    });
};
export const trackCouponInfoButtonClicked = (params)=>{
    mixpanelEvent("Coupon Info Button Clicked", {
        Position: "마이 쏠북",
        "Button Name": params.buttonName,
        "Button Url": params.buttonUrl
    });
};
export const trackMembershipInfoButtonClicked = (params)=>{
    mixpanelEvent("Membership Info Button Clicked", {
        Position: "마이 쏠북",
        "Button Name": params.buttonName,
        ...params.buttonUrl !== undefined && {
            "Button Url": params.buttonUrl
        },
        Title: params.title,
        "Remaining Days": params.remainingDays
    });
};
export const trackPasswordChangeButtonClicked = ()=>{
    mixpanelEvent("Password Change Button Clicked", {
        Position: "내 정보 관리"
    });
};
export const trackPasswordChangeCompleted = ()=>{
    mixpanelEvent("Password Change Completed", {
        Position: "비밀번호 변경"
    });
};
export const trackProfileInfoEditTry = (params)=>{
    mixpanelEvent("Profile Info Edit Try", {
        Position: "내 정보 관리",
        "Edit Item": params.editItem,
        ...params.asIs !== undefined && {
            "As Is": params.asIs
        },
        ...params.toBe !== undefined && {
            "To Be": params.toBe
        }
    });
};
export const trackProfileInfoEditCompleted = (params)=>{
    mixpanelEvent("Profile Info Edit Completed", {
        Position: "내 정보 관리",
        "Edit Item": params.editItem,
        ...params.asIs !== undefined && {
            "As Is": params.asIs
        },
        ...params.toBe !== undefined && {
            "To Be": params.toBe
        }
    });
};
export const trackSchoolDialogueViewed = ()=>{
    mixpanelEvent("School Dialogue Viewed", {
        Position: "내 정보 관리"
    });
};
export const trackSchoolDialogCloseUI = ()=>{
    mixpanelEvent("Close UI", {
        Type: "닫기(X) 아이콘",
        Position: "주요 학교 등록 다이얼로그"
    });
};
export const trackDeleteAccountButtonClicked = ()=>{
    mixpanelEvent("Delete Account Button Clicked", {
        Position: "내 정보 관리"
    });
};
export const trackDeleteAccountPopupViewed = ()=>{
    mixpanelEvent("Popup Viewed", {
        Position: "내 정보 관리",
        "Popup Type": "회원 탈퇴",
        "Popup Title": "회원 탈퇴 확인"
    });
};
export const trackDeleteAccountPopupButtonClicked = (params)=>{
    mixpanelEvent("Popup Button Clicked", {
        Position: "내 정보 관리",
        "Popup Type": "회원 탈퇴",
        "Popup Title": "회원 탈퇴 확인",
        "Button Name": params.buttonName
    });
};
export const trackDeleteAccountCompleted = ()=>{
    mixpanelEvent("Delete Account Completed");
};
// /mypage/orders ──────────────────────────
// Snackbar Opened (MX-588 환불 불가) 는 useSnackbar store에서 position 옵션으로 처리.
export const trackOrderCompositionPopupViewed = ()=>{
    mixpanelEvent("Popup Viewed", {
        Position: "주문 내역",
        "Popup Type": "상품 구성",
        "Popup Title": "상품 구성"
    });
};
export const trackOrderCompositionPopupButtonClicked = (params)=>{
    mixpanelEvent("Popup Button Clicked", {
        Position: "주문 내역",
        "Popup Type": "상품 구성",
        "Popup Title": "상품 구성",
        "Button Name": params.buttonName,
        "Button Url": params.buttonUrl
    });
};
export const trackOrderCompositionCloseUI = (type)=>{
    mixpanelEvent("Close UI", {
        Position: "주문 내역 - 상품 구성 다이얼로그",
        Type: type
    });
};
export const trackBankTransferPopupViewed = ()=>{
    mixpanelEvent("Popup Viewed", {
        Position: "주문 내역",
        "Popup Type": "입금 정보",
        "Popup Title": "입금 정보"
    });
};
export const trackBankTransferClipboardPasteIconClicked = (params)=>{
    mixpanelEvent("Clipboard Paste Icon Clicked", {
        Position: "주문 내역 - 입금 정보 다이얼로그",
        Type: "계좌번호 복사",
        "Order Id": params.orderId,
        "Order Type": params.orderType
    });
};
// MX-635
export const trackCheckoutCompleteVirtualAccountClipboardPasteIconClicked = (params)=>{
    mixpanelEvent("Clipboard Paste Icon Clicked", {
        Position: "결제 완료 (가상계좌)",
        Type: "계좌번호 복사",
        "Order Id": params.orderId,
        "Order Type": params.orderType
    });
};
export const trackOrderNumberClipboardPasteIconClicked = (params)=>{
    mixpanelEvent("Clipboard Paste Icon Clicked", {
        Position: "주문 내역",
        Type: "주문번호 복사",
        "Order Id": params.orderId,
        "Order Type": params.orderType
    });
};
export const trackOrderModuleButtonClicked = (params)=>{
    mixpanelEvent("Order Module Button Clicked", {
        Position: "주문 내역",
        "Button Name": params.buttonName,
        "Order Id": params.orderId,
        "Order Type": params.orderType
    });
};
// /mypage/orders/:id/refund ────────────────────────────────────
// MX-525a
export const trackRefundInvalidOrderPopupViewed = (popupTitle)=>{
    mixpanelEvent("Popup Viewed", {
        Position: "환불 상품 선택",
        "Popup Type": "유효하지 않은 주문",
        "Popup Title": popupTitle
    });
};
// MX-525b
export const trackRefundInvalidOrderPopupButtonClicked = (popupTitle)=>{
    mixpanelEvent("Popup Button Clicked", {
        Position: "환불 상품 선택",
        "Popup Type": "유효하지 않은 주문",
        "Popup Title": popupTitle,
        "Button Name": "쏠북으로 돌아가기"
    });
};
export const trackRefundCheckboxUIClicked = (type, status)=>{
    mixpanelEvent("Checkbox UI Clicked", {
        Position: "환불 상품 선택",
        Type: type,
        Status: status
    });
};
export const trackRefundProductTabUIClicked = (tabName)=>{
    mixpanelEvent("Tab UI Clicked", {
        Position: "환불 상품 선택",
        "Tab Type": "환불 상품 선택",
        "Tab Name": tabName
    });
};
export const trackRefundSelected = (params)=>{
    mixpanelEvent("Refund Selected", {
        Position: "환불 상품 선택",
        "Request Id": params.requestId,
        "Order Id": params.orderId,
        "Order Type": params.orderType
    });
};
// MX-533
const REFUND_REASON_LABELS = [
    "단순 변심",
    "잘못 구매",
    "다른 상품 구매",
    "퀄리티에 문제가 있음",
    "서비스에 문제가 있음",
    "기타"
];
export const trackRefundRequested = (params)=>{
    const reasonProps = {};
    REFUND_REASON_LABELS.forEach((label)=>{
        reasonProps["Reason(".concat(label, ")")] = params.selectedReasonLabels.includes(label);
    });
    mixpanelEvent("Refund Requested", {
        Position: "환불 사유",
        "Request Id": params.requestId,
        "Order Id": params.orderId,
        "Order Type": params.orderType,
        ...reasonProps,
        "Reason(상세 사유)": params.reasonDetail
    });
};
export const trackRefundCompleted = (params)=>{
    mixpanelEvent("Refund Completed", {
        Position: "환불 완료",
        "Request Id": params.requestId,
        "Order Id": params.orderId,
        "Order Type": params.orderType,
        "Item Num": params.itemCount,
        "Item Title": params.itemTitles,
        "Refund Total Price": params.refundTotalPrice
    });
};
// MX-535
export const trackRefundCompleteMoreButtonClicked = ()=>{
    mixpanelEvent("More Button Clicked", {
        Position: "환불 완료",
        "Button Name": "전체 보기",
        "Button Type": "환불 완료된 상품 전체보기"
    });
};
export const trackRefundGuideButtonClicked = (category, url)=>{
    mixpanelEvent("Guide Button Clicked", {
        Position: "환불 완료",
        "Guide Categories": category,
        "Guide URL": url
    });
};
// MX-538
export const trackRefundCompleteCtaButtonClicked = ()=>{
    mixpanelEvent("CTA Button Clicked", {
        Position: "환불 완료",
        "Button Name": "주문내역 돌아가기"
    });
};
// MX-539
export const trackRefundCompleteCloseUI = ()=>{
    mixpanelEvent("Close UI", {
        Position: "환불 완료",
        Type: "닫기(X) 아이콘"
    });
};
// MX-600
export const trackRefundNonRefundableChannelTalkLinkClicked = (url)=>{
    mixpanelEvent("Link Button Clicked", {
        Position: "환불 상품 선택 - 환불 불가 탭",
        "Button Name": "고객센터 - 채널톡 연결",
        "Button Url": url
    });
};
/** MX-155 — 구독 모듈의 '구독 해지' 버튼 클릭 시 */ export const trackUnsubscribeButtonClicked = (params)=>{
    mixpanelEvent("Unsubscribe Button Clicked", {
        Position: params.position,
        "Membership Id": params.subscriptionId,
        "Product Title": params.title,
        "Is Free Trial": params.isFreeTrial
    });
};
// 사유 라벨 스냅샷 — 상수(SUBSCRIPTION_CANCEL_REASONS)가 바뀌어도 지표 프로퍼티 키는 유지돼야 해서 분리 정의
const SUBSCRIPTION_CANCEL_REASON_LABELS = [
    "월구독 비용이 부담돼요.",
    "다른 상품으로 변경하려고 해요.",
    "내신 기간, 시험기간에만 사용해서 잠시 중지해요.",
    "타 유사 서비스를 사용할 계획이에요.",
    "원하는 자료가 없어요.",
    "기타"
];
/** MX-654 — 해지 사유 선택 후 '해지하기' 클릭 시 */ export const trackUnsubscribeRequested = (params)=>{
    const reasonProps = {};
    SUBSCRIPTION_CANCEL_REASON_LABELS.forEach((label)=>{
        reasonProps["Reason(".concat(label, ")")] = params.selectedReasonLabels.includes(label);
    });
    mixpanelEvent("Unsubscribe Requested", {
        Position: "구독 해지 사유",
        "Request Id": params.requestId,
        "Membership Id": params.subscriptionId,
        "Product Title": params.title,
        ...reasonProps,
        "Reason(상세 사유)": params.reasonDetail
    });
};
/**
 * MX-655 — 최종 해지 처리가 서버에서 확정된 시점.
 *
 * 환불액은 보내지 않는다. 해지는 만료일까지 유지되는 예약이고 환불은 그 뒤 별도 요청이라
 * (`MySubscription.refundableOrderId`), 이 시점의 환불액은 0 이다.
 *
 * TODO(BE): 지표 정의의 `Subscription Day Count`(최초 결제일~해지 경과 일수)와
 * `Membership Id`(구독 상품 id, 숫자)를 아직 못 보낸다. 응답에 최초 결제일도 상품 id도 없고,
 * `period.startsAt` 은 이번 회차 결제 시각이라 2회차 이상에서 경과 일수가 어긋난다.
 * 현재 `Membership Id` 에는 구독 id(uuid)가 나간다.
 */ export const trackUnsubscribeCompleted = (params)=>{
    mixpanelEvent("Unsubscribe Completed", {
        Position: "구독 관리",
        "Request Id": params.requestId,
        "Membership Id": params.subscriptionId,
        "Product Title": params.title,
        "Is Free Trial": params.isFreeTrial,
        "Module Type": params.moduleType
    });
};
/** MX-656 — '구독 해지 취소' 가 서버에서 확정된 시점 */ export const trackUnsubscribeCancelCompleted = (params)=>{
    mixpanelEvent("Unsubscribe Cancel Completed", {
        Position: params.position,
        "Membership Id": params.subscriptionId,
        "Product Title": params.title,
        "Is Free Trial": params.isFreeTrial,
        "Remaining Day Count": params.remainingDayCount
    });
};
